<template>
    <div class="warp" v-if="schoolCode == '10008'">
        <Header title="学生信息查询"></Header>
        <div class="content">
            <div class="search">
                <i class="icon_search"></i>
                <input type="text" style="width: calc(100% - 31px)" placeholder="请输入学号/姓名" v-model="xsss" @keyup.enter="getXsxxList()" />
            </div>
            <div class="select">
                <div class="grade" @click="clickGrade">
                    {{ this.njmc == '' ? '年级' : this.njmc }}
                    <div class="jiantou"></div>
                </div>
                <div class="college" @click="clickCollege">
                    {{ this.xymc == '' ? '院系' : this.xymc }}
                    <div class="jiantou"></div>
                </div>
                <div class="studentStatus" @click="clickStudentStatus">
                    {{ this.xjmc == '' ? '学籍状态' : this.xjmc }}
                    <div class="jiantou"></div>
                </div>
            </div>
            <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
            </van-popup>
            <van-popup v-model="showPicker1" position="bottom">
                <van-picker show-toolbar :columns="columns1" @cancel="showPicker1 = false" @confirm="onConfirm1" />
            </van-popup>
            <van-popup v-model="showPicker2" position="bottom">
                <van-picker show-toolbar :columns="columns2" @cancel="showPicker2 = false" @confirm="onConfirm2" />
            </van-popup>
        </div>
        <div class="main" v-for="(item, index) in dataList" :key="index">
            <div class="outlayer">
                <div class="box">
                    <div class="boxl">
                        <div class="name">
                            <div>{{ item.xm }}</div>
                            <template v-if="item.xjzt == '无学籍'">
                                <div style="color:#999999;border:1px solid #999999;">{{ item.xjzt }}</div>
                            </template>
                            <template v-else>
                                <div>{{ item.xjzt }}</div>
                            </template>
                        </div>
                        <div class="info">
                            <div class="studentNumber">{{ item.xh }}</div>
                            <div class="studentClass">{{ item.bj }}</div>
                        </div>
                    </div>
                    <div :class="{ active: showList[index] }" class="boxr" @click="isShow(item, index)">
                        <img src="../../../../../static/img/arrow-up_proc.jpg" alt="" />
                    </div>
                </div>
                <div class="details" v-show="showList[index]">
                    <div class="studentStatus" @click="goStudentStatus(item)">学籍</div>
                    <div class="change" @click="goChange(item)">异动</div>
                    <div class="timetable" @click="goInformationInquiryTimetable(item)">课表</div>
                    <div class="achievement" @click="goAchievement(item)">成绩</div>
                    <div class="innovationCredits" @click="goInnovationCredits(item)">创新学分</div>
                    <div class="testArrangement" @click="goExamination(item)">排考</div>
                </div>
            </div>
        </div>
        <NOdata title="暂无搜索结果~" v-if="this.dataList.length == 0"></NOdata>
    </div>
</template>

<script>
import { Api } from '../../../../utils/axios';

export default {
    data() {
        return {
            schoolCode: '',
            //搜索
            xsss: '',
            //年级
            showPicker: false,
            columns: [],
            njmc: '',
            //学院
            showPicker1: false,
            columns1: [],
            xymc: '',
            //学籍
            showPicker2: false,
            columns2: [],
            xjmc: '',

            show: false,
            dataList: [],
            chioesItem: {},
            showList: [],
            showArr: []
        };
    },
    created() {
        this.schoolCode = sessionStorage.getItem('schoolCode');
        //获取年级
        this.getGrade();
        // 获取院系
        this.getDepartment();
        //获取学籍状态
        this.getXsxjzt();
        //获取学生信息列表
        this.getXsxxList();
    },
    methods: {
        //获取年级
        async getGrade() {
            const gradeResults = await Api.getGradeList();
            for (let i = 0; i < gradeResults.data.length; i++) {
                this.columns.push(gradeResults.data[i].gradeName);
            }
        },
        clickGrade() {
            this.showPicker = true;
        },
        onConfirm(value) {
            this.njmc = value;
            this.showPicker = false;
            this.getXsxxList();
        },
        // 获取院系
        async getDepartment() {
            const departmentResults = await Api.allyx();
            this.columns1 = departmentResults.data.map((item) => {
                return {
                    value: item.academyId,
                    text: item.academyName
                };
            });
        },
        clickCollege() {
            this.showPicker1 = true;
        },
        onConfirm1(value) {
            this.xymc = value.text;
            this.xyid = value.value;
            this.showPicker1 = false;
            this.getXsxxList();
        },
        // 学籍
        async getXsxjzt() {
            const studentStatusResults = await Api.getXsxjzt();
            this.columns2 = studentStatusResults.data.map((item, index) => {
                return {
                    value: item.dm,
                    text: item.dmmc
                };
            });
        },
        clickStudentStatus() {
            this.showPicker2 = true;
        },
        onConfirm2(value) {
            this.xjmc = value.text;
            this.xjid = value.value;
            this.showPicker2 = false;
            this.getXsxxList();
        },
        //获取学生信息列表
        async getXsxxList() {
            const params = {
                xsnj: this.njmc,
                xsyx: this.xyid,
                xjzt: this.xjid,
                xhxm: this.xsss
            };
            const xsxxListResults = await Api.getXsxxList(params);
            this.dataList = xsxxListResults.data;
        },
        //点击显示隐藏
        isShow(item, index) {
            this.chioesItem = item;
            // if (this.show) {
            //     this.show = false;
            // } else {
            //     this.show = true;
            // }
            // !true !false
            // --
            // let bl;
            // if (this.showList[index]) {
            //     bl = false;
            // } else {
            //     bl = true;
            // }
            // let bl = !this.showList[index];
            // this.$set(this.showList, index, bl);
            let arr = [];
            this.showArr[index] = !this.showArr[index];
            let indexval = this.showArr[index];
            arr[index] = indexval;
            this.showList = arr;
        },
        //学籍跳转
        goStudentStatus(item) {
            this.$router.push({ path: '/informationService/studentStatus', query: { xs0101id: item.xs0101id } });
        },
        //异动
        goChange(item) {
            this.$router.push({
                path: '/informationService/change',
                query: {
                    xs0101id: item.xs0101id,
                    xm: item.xm,
                    xh: item.xh,
                    xsnj: item.xsnj,
                    dwmc: item.dwmc,
                    zymc: item.zymc,
                    bj: item.bj
                }
            });
        },
        //课程表
        goInformationInquiryTimetable(item) {
            this.$router.push({ path: '/informationService/informationInquiryTimetable', query: { xs0101id: item.xs0101id, xm: item.xm, xh: item.xh } });
        },
        //成绩
        goAchievement(item) {
            this.$router.push({ path: '/informationService/achievement', query: { xs0101id: item.xs0101id, xm: item.xm, xh: item.xh, xsnj: item.xsnj, bj: item.bj } });
        },
        //创业创新学分
        goInnovationCredits(item) {
            this.$router.push({ path: '/informationService/innovationCredits', query: { xs0101id: item.xs0101id, xm: item.xm, xh: item.xh, xsnj: item.xsnj, bj: item.bj } });
        },
        //考试
        goExamination(item) {
            this.$router.push({ path: '/informationService/examination', query: { xs0101id: item.xs0101id, xm: item.xm, xh: item.xh, xsnj: item.xsnj, bj: item.bj } });
        }
    }
};
</script>

<style scoped>
.content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.warp .search {
    width: 90%;
    height: 35px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0 15px;
    background-color: #f4f4f4;
    padding: 10px 20px;
}
.warp .search .icon_search {
    width: 20px;
    height: 20px;
    background: url(../../../../../static/img/search.png) no-repeat;
    background-size: 100%;
    margin-right: 11px;
}
.warp .search input {
    background: none;
}
.select {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 15px;
}
.jiantou {
    display: inline-block;
    border-bottom: 1px solid;
    border-left: 1px solid;
    width: 5px;
    height: 5px;
    border-color: #b2b2b2;
    transform: rotate(-45deg);
    transition: all 0.4s ease;
    margin: 3px;
}
.main {
    padding: 10px 20px;
}
.outlayer {
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
}
.box {
    display: flex;
    justify-content: space-between;
}
.name {
    display: flex;
}
.name > div:first-child {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
}
.name > div:last-child {
    width: 50px;
    height: 19px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    color: #41b29c;
    border: 1px solid #00b59b;
    border-radius: 9.5px;
    margin-left: 5px;
}
.info {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-top: 3px;
}
.info > div:last-child {
    margin-left: 10px;
}
.boxr {
    width: 32px;
    height: 32px;
    background: #f2f2f4;
    border-radius: 16px;
}
.boxr > img {
    margin: 10px;
    transition: all 0.1s ease-in 0.1s;
}
.boxr.active > img {
    transform: rotate(180deg);
}
.details {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    font-weight: 400;
    font-size: 14px;
    color: #0189f9;
}
.details > div {
    width: 20%;
    height: 32px;
    background-color: rgba(242, 242, 244, 1);
    border-radius: 16px;
    text-align: center;
    margin: 8px 12px 8px 0;
    line-height: 32px;
}
.details > div:hover {
    background-color: rgba(1, 137, 249, 0.15);
    color: #0189f9;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/informationService/index.vue